/** ----------------------------------------
    Apply routes
---------------------------------------- */

import auth from '@middleware/auth';

const routes = [
    {
        path: '/apply',
        redirect: '/apply/new',
        meta: {
            middleware: [auth],
            reqAuth: true,
        },
        component: () => import('@view/templates/Apply.vue'),
        children: [
            {
                path: ':project',
                name: 'apply.project',
                redirect: '/apply/new/applicant/intro',
                component: () => import('@view/templates/ApplyProject.vue'),
                children: [
                    {
                        path: ':group',
                        name: 'apply.group',
                        redirect: '/apply/new/applicant/intro',
                        component: () => import('@view/templates/ApplyGroup.vue'),
                        children: [
                            {
                                path: ':step',
                                name: 'apply.step',
                                component: () => import('@view/templates/ApplyStep.vue'),
                            },
                        ],
                    },
                ],
            },
        ]
        
    },
],
 
/** ----------------------------------------
    Export Modules
---------------------------------------- */

export default routes;